<div class="sabis-tree-combobox">
  <div class="sc-control">
    <div>
      @if (scLabel) {
        <label class="control-label">
          {{ scLabel }}
          <span class="sc-required sabis-tree-combobox__required-star"></span>
        </label>
      }
    </div>

    <div class="sabis-tree-combobox__input-wrapper">
      <input #autoCompleteInput
        type="text"
        placeholder="{{ 'SabisComponents.TreeCombobox.SelectOptionMessage' | translate }}"
        class="sabis-text"
        matInput
        [value]="selectionSummary"
        [disabled]="isDisabled"
        [matAutocomplete]="auto"
        readonly
        (click)="openPanel($event)" />
        <mat-icon class="sabis-tree-combobox__dropdown-arrow"
          [class.disabled]="isDisabled"
          [class.open]="isPanelOpen"
          (click)="!isDisabled && openPanel($event)">
          arrow_drop_down
        </mat-icon>
      </div>

      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option>
          <div class="sabis-tree-combobox__search-container">
            <input #searchInput
              name="tree-combobox-search-input"
              class="sabis-tree-combobox__search-container__search-input"
              autocomplete="off"
              [(ngModel)]="filterText"
              (ngModelChange)="onFilterChanged($event)"
              (click)="$event.stopPropagation()"
              placeholder="{{'SabisComponents.ComboboxSearchPlaceHolderLabel' | translate}}" />
              @if (filterText) {
                <button
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearSearch($event)"
                  class="sabis-tree-combobox__search-container__clear-button">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          </mat-option>
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- leaf node -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
              <button mat-icon-button disabled></button>
              <mat-checkbox class="checklist-leaf-node"
                (change)="checkboxClick(node, true, false)"
                [checked]="node.isChecked">
                <span [innerHtml]="node.displayName"></span>
              </mat-checkbox>
            </mat-tree-node>

            <!-- node with children -->
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
              <button mat-icon-button
                matTreeNodeToggle
                [attr.aria-label]="'toggle ' + node.filename">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>

              @if (scMultiple) {
                <mat-checkbox [checked]="node.isChecked"
                  [indeterminate]="node.isPartiallyChecked"
                  (change)="checkboxClick(node, false, false)">
                  <span [innerHtml]="node.displayName"></span>
                </mat-checkbox>
              }
              @if (!scMultiple) {
                <span [innerHtml]="node.displayName"></span>
              }
            </mat-tree-node>
          </mat-tree>
        </mat-autocomplete>
      </div>
      @if (!scHideValidationMessage && !isValid) {
        <p class="sc-error-message">{{ validationMessage }}</p>
      }
    </div>
